import { render, staticRenderFns } from "./SponsorsExampleDialog.vue?vue&type=template&id=6bf687c0"
import script from "./SponsorsExampleDialog.vue?vue&type=script&lang=js"
export * from "./SponsorsExampleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports